



































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import format from '@/libs/numberFormat';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import dayjs from 'dayjs';

@Component({
  components: {
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    ScrollbarWrapper,
    ActionPopup,
  },
  methods: {
    format,
    dayjs,
  },
})
export default class ReportTable extends Vue {
  @Prop(Array) data!: [];
  @Prop(Array) label!: object;
  @Prop(Array) all!: object;
  @Prop(Number) merchant!: number;
  @Prop() total!: string;
  format!: typeof format;
  dayjs!: typeof dayjs;

  totalOutstanding = '';

  @Watch('total')
  async getData() {
    this.totalOutstanding = format(parseFloat(this.total), true);
  }
}
